import { createFileRoute } from "@tanstack/react-router";
// Direct files, not the feature's index: this route's loader ships in every
// page's first download.
import { womenTripsQueryOptions } from "../../../features/women/api/women-query";
import { parseWomenHubSearch, type WomenHubSearch } from "../../../features/women/lib/trip-filters";
import { WomenHubPage } from "../../../features/women/pages/women-hub-page";

/**
 * `/{lang}/women`: the women-only trips hub. Loaded on the server so the
 * cards (and their links) are in the HTML a crawler reads. The chips only
 * change `?when=` and `?from=`, which filter the same list: no refetch.
 */
export const Route = createFileRoute("/$lang/_layout/women")({
  validateSearch: (search: Record<string, unknown>): WomenHubSearch => parseWomenHubSearch(search),
  loader: async ({ context, params }) => {
    await context.queryClient.ensureQueryData(womenTripsQueryOptions(params.lang));
  },
  component: WomenRoute,
});

function WomenRoute() {
  const { lang } = Route.useParams();
  const search = Route.useSearch();
  return <WomenHubPage lang={lang} search={search} />;
}
